export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SET_ALL_MSG = 'SET_ALL_MSG'
export const SET_CHAT_MSG = 'SET_CHAT_MSG'
export const SET_ROOM_STATE_MSG = 'SET_ROOM_STATE_MSG'
export const SET_SOCKET = 'SET_SOCKET'
export const SET_TTM_MSG = 'SET_TTM_MSG'
export const SET_AUDIO_MESSAGE = 'SET_AUDIO_MESSAGE'
export const SET_NOTE_MESSAGE = 'SET_NOTE_MESSAGE'
export const DELETE_NOTE_MESSAGE = 'DELETE_NOTE_MESSAGE'
export const FETCH_NOTES_MESSAGES = 'FETCH_NOTES_MESSAGES'
export const POPULATE_DUMMY_NOTES_MESSAGES = 'POPULATE_DUMMY_NOTES_MESSAGES'
export const SET_SENDER_ID_FOR_DUMMY_NOTES = 'SET_SENDER_ID_FOR_DUMMY_NOTES'
export const HANDLE_SEND_SOCKET_MESSAGE = 'HANDLE_SEND_SOCKET_MESSAGE'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const RESET_WEB_SOCKET_STATE = 'RESET_WEB_SOCKET_STATE'
export const RESET_GENERAL_MESSAGES = 'RESET_GENERAL_MESSAGES'
export const SET_IS_IFRAME_SHARED = 'SET_IS_IFRAME_SHARED'
